import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactEcharts from 'echarts-for-react';
import { Col, DatePicker, Row, Select, Spin, } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as channelController from '../../../../../../services/api/channel';
import * as programmeController from '../../../../../../services/api/programme';
import { leadTypeOptions, leadSourceOptions, leadStatusOptions } from '../../../../../../utils/options';

const { RangePicker } = DatePicker;
const { Option } = Select;

export class ProgrammeInsight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            programmes: [],
            channels: [],
            selectedChannels: [],
            selectedDateRanges: [moment().subtract(7, 'days'), moment()],
            selectedLeadSource: undefined,
            selectedLeadType: undefined,
            selectedLeadStatus: undefined,
            overallDistribution: {
                numberOfEnrolledLead: 0,
                numberOfLead: 0,
            },
            totalDistribution: {
                numberOfEnrolledLead: 0,
                numberOfLead: 0,
            },
            programmeChannelDistribution: {
                numberOfEnrolledLead: [],
                numberOfLead: [],
            },
            isLoading: false
        }
    }

    fetchProgrammes() {
        this.setState({ isLoading: true });

        programmeController.getProgrammes({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json, isLoading: false }))
    }

    fetchChannels() {
        this.setState({ isLoading: true });

        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json, isLoading: false }))
    }

    fetchOverallDistribution() {
        const { match } = this.props;
        const { selectedDateRanges, selectedChannels, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        const programmeId = match.params.programmeId;
        this.setState({ isLoading: true });

        programmeController.getProgrammeOverallDistribution({
                programme_id: programmeId,
                channel_ids: selectedChannels,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                let newState = { isLoading: false };

                if (json.length !== 0) {
                    newState.overallDistribution = {
                        numberOfEnrolledLead: json[0].number_of_enrolled_lead,
                        numberOfLead: json[0].number_of_lead
                    }
                } else {
                    newState.overallDistribution = {
                        numberOfEnrolledLead: 0,
                        numberOfLead: 0
                    }
                }

                this.setState(newState);
            })
    }

    fetchTotalDistribution() {
        const { match } = this.props;
        const programmeId = match.params.programmeId;
        this.setState({ isLoading: true });

        programmeController.getProgrammeOverallDistribution({
                programme_id: programmeId
            })
            .then((res) => res.json())
            .then((json) => {
                let newState = { isLoading: false };

                if (json.length !== 0) {
                    newState.totalDistribution = {
                        numberOfEnrolledLead: json[0].number_of_enrolled_lead,
                        numberOfLead: json[0].number_of_lead
                    }
                }

                this.setState(newState);
            })
    }

    fetchProgrammeChannelDistribution() {
        const { match } = this.props;
        const { selectedChannels, selectedDateRanges, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        const programmeId = match.params.programmeId;
        this.setState({ isLoading: true });

        programmeController.getProgrammeChannelDistribution({
                programme_id: programmeId,
                channel_ids: selectedChannels,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                let leadResults = [],
                    enrolledLeadResults = [];

                _.forEach(selectedChannels, (channel) => {
                    const targetChannel = _.find(json, { channel_id: channel }) || {};
                    leadResults.push(targetChannel.number_of_lead || 0);
                    enrolledLeadResults.push(targetChannel.number_of_enrolled_lead || 0)
                });

                this.setState({ programmeChannelDistribution: { numberOfLead: leadResults, numberOfEnrolledLead: enrolledLeadResults }, isLoading: false });
            })
    }

    getProgrammeChartOption() {
        const { channels, selectedChannels, programmeChannelDistribution } = this.state;

        const option = {
            tooltip: {
                trigger: 'axis',
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        title: 'Save as image'
                    }
                }
            },
            xAxis: [{
                type: 'category',
                data: _.map(selectedChannels, (channel) => (_.find(channels, { id: channel }) || {}).name || channel)
            }],
            yAxis: {
                type: 'value',
                axisPointer: {
                    snap: true
                },
                interval: 1
            },
            legend: {
                data: ['Lead', 'Enrolled Lead']
            },
            series: [{
                name: 'Lead',
                type: 'bar',
                data: programmeChannelDistribution.numberOfLead
            }, {
                name: 'Enrolled Lead',
                type: 'bar',
                data: programmeChannelDistribution.numberOfEnrolledLead
            }]
        };

        return option;
    }

    componentDidMount() {
        this.fetchProgrammes();
        this.fetchChannels();
        this.fetchOverallDistribution();
        this.fetchTotalDistribution();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            channels,
            selectedChannels,
            selectedDateRanges,
            selectedLeadSource,
            selectedLeadType,
            selectedLeadStatus
        } = this.state;

        if ((!_.isEqual(channels, prevState.channels) && channels.length !== 0) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            !_.isEqual(selectedDateRanges, prevState.selectedDateRanges) ||
            selectedLeadSource !== prevState.selectedLeadSource ||
            selectedLeadType !== prevState.selectedLeadType ||
            selectedLeadStatus !== prevState.selectedLeadStatus) {
            this.fetchProgrammeChannelDistribution();
        }

        if (!_.isEqual(selectedDateRanges, prevState.selectedDateRanges) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            selectedLeadSource !== prevState.selectedLeadSource ||
            selectedLeadType !== prevState.selectedLeadType ||
            selectedLeadStatus !== prevState.selectedLeadStatus) {
            this.fetchOverallDistribution();
        }
    }

    render() {
        const { match } = this.props;
        const {
            channels,
            programmes,
            selectedChannels,
            selectedDateRanges,
            selectedLeadSource,
            selectedLeadType,
            selectedLeadStatus,
            overallDistribution,
            totalDistribution,
            isLoading
        } = this.state;
        const programmeId = match.params.programmeId;
        const currentProgrammeName = (_.find(programmes, { id: parseInt(programmeId, 10) }) || {}).name || programmeId;

        const channelOptions = _.map(channels, (channel) => <Option key={channel.id} value={channel.id}>{channel.name}</Option>);
        const leadSourceOptionComponents = _.map(leadSourceOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadTypeOptionComponents = _.map(leadTypeOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadStatusOptionComponents = _.map(leadStatusOptions, (item) => <Option key={item} value={item}>{item}</Option>);

        return (
            <Spin spinning={isLoading}>
                <div className="InsightSection">
                    <Row gutter={16} className="option-bar">
                        <Col span={24}>
                            <div className="query-option">
                                <label>Select Channel(s): </label>
                                <Select
                                    mode="multiple"
                                    style={{ width: 500 }}
                                    value={selectedChannels}
                                    onChange={(value) => this.setState({ selectedChannels: value} )}
                                >
                                    {channelOptions}
                                </Select>
                            </div>
                            {" "}
                            <div className="query-option">
                                <label>Select Range: </label>
                                <RangePicker
                                    value={selectedDateRanges}
                                    onChange={(dates, dateStrings) => this.setState({ selectedDateRanges: dates })}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16} className="option-bar">
                        <Col span={24}>
                            <div className="query-option">
                                <label>Lead Source: </label>
                                <Select
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    vallue={selectedLeadSource}
                                    onChange={(value) => this.setState({ selectedLeadSource: value })}
                                >
                                    {leadSourceOptionComponents}
                                </Select>
                            </div>
                            {" "}
                            <div className="query-option">
                                <label>Lead Type: </label>
                                <Select
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    vallue={selectedLeadType}
                                    onChange={(value) => this.setState({ selectedLeadType: value })}
                                >
                                    {leadTypeOptionComponents}
                                </Select>
                            </div>
                            {" "}
                            <div className="query-option">
                                <label>Lead Status: </label>
                                <Select
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    vallue={selectedLeadStatus}
                                    onChange={(value) => this.setState({ selectedLeadStatus: value })}
                                >
                                    {leadStatusOptionComponents}
                                </Select>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} xs={24}>
                            <h3>{`Distribution within the range (${currentProgrammeName})`}</h3>
                            <p>Number of Enrolled Lead: {overallDistribution.numberOfEnrolledLead}</p>
                            <p>Number of Lead: {overallDistribution.numberOfLead}</p>
                        </Col>
                        <Col lg={12} xs={24}>
                            <h3>{`Total as of today (${currentProgrammeName})`}</h3>
                            <p>Number of Enrolled Lead: {totalDistribution.numberOfEnrolledLead}</p>
                            <p>Number of Lead: {totalDistribution.numberOfLead}</p>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <h3>Enrollment & Lead distribution across channel</h3>
                            <ReactEcharts
                                style={{ height: '500px'}}
                                notMerge
                                theme={'informatics'}
                                option={this.getProgrammeChartOption()}
                            />
                        </Col>
                    </Row>
                </div>
            </Spin>
        );
    }
}

export default withRouter(ProgrammeInsight);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProgrammeManagementPage/components/ProgrammeInsight/ProgrammeInsight.js